import { useUser } from "@/contexts/UserContext";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const InstructionGuard: React.FC = () => {
  const { user, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!user) navigate;
  }, [isLoading, user, navigate]);
  if (isLoading || !user) return null;
  return <Outlet />;
};

export default InstructionGuard;
